import React, { PureComponent } from 'react';
// Components

interface BoardPreviewProps {}
export default class BoardPreview extends PureComponent<BoardPreviewProps> {
  render() {
    return (
      <div className="padding">
        <h2 className="text-fade text-center">Better preview of board is coming soon</h2>
      </div>
    );
  }
}
